<!--登录日志-->
<template>
    <div>
        <Log :columns="columns" :xiangqing="false" @getData="init" @deleteOpe="deleteSubmit"></Log>
    </div>
</template>

<script>
    import Log from '@/components/log/Log'
    import {logLoginPage,logLoginRemove} from '@/api/log'

    export default {
        name: 'SYS-LOG-LOGIN',
        components: {
            Log
        },
        data() {
            return {
                columns: [
                    {
                        type:'selection',
                        width: '55px',
                        fixed: 'left'
                    }, {
                        label: '序号',
                        prop: 'id',
                        fixed: 'left',
                        width: '55px'
                    }, {
                        label: 'ip地址',
                        prop: 'ip',
                        width: '120px'
                    }, {
                        label: '定位',
                        prop: 'location',
                        width: '120px'
                    }, {
                        label: '用户名',
                        prop: 'loginName',
                        width: '120px'
                    }, {
                        label: '登录时间',
                        prop: 'loginTime',
                        width: '150px'
                    }, {
                        label: '登录类型',
                        prop: 'loginType',
                        width: '100px'
                    }, {
                        label: '登录信息',
                        prop: 'msg',
                        //width: '200px'
                    }, {
                        label: '操作系统',
                        prop: 'os',
                        width: '150px'
                    }, {
                        label: '状态',
                        prop: 'status',
                        width: '80px'
                    }, {
                        label: '操作',
                        type: 'template',
                        template: 'action',
                        width: '160px',
                        fixed: 'right'
                    }
                ]
            }
        },
        methods: {
            init(param,data,e) {
                logLoginPage(param, data).then(response => {
                    if (response.code != 200)
                        return e.$message.error(response.msg)
                    e.tablelist = response.data.records
                    e.total = response.data.total
                    e.loading = false
                })
            },
            deleteSubmit(item,e){
                let ids=''
                if(item===''){
                    ids=e.checkedList.map((item)=>{return item.id}).join(',')
                }else{
                    ids=item.id
                }
                logLoginRemove(ids).then(response => {
                    console.log('删除登录日志结果',response)
                    if(response.code!=200){
                        return e.$message.error(response.msg)
                    }
                    e.init()
                    e.$message.success(response.msg)
                })
            }
        }
    }
</script>

<style scoped>

</style>
